import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'

// [RSA] 키 발급 요청
const getRSA = async function () {
  const url = `${ApiConfig.eklDomain}/v1/ebmp/common/util/encDec/keyIssuance`
  let publicKey = ''
  await ApiUtil.get(url).then(response => {
    if (response.data === undefined || response.data.resultStatus === undefined) {
      kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
      return false
    }
    const resultStatus = response.data.resultStatus
    if (resultStatus.messageCode !== '2000') {
      kendo.alert(resultStatus.messageText)
      return false
    }

    publicKey = {
      publicKeyModulus : response.data.resultData.publicKeyModulus,
      publicKeyExponent : response.data.resultData.publicKeyExponent
    }
  })
  return publicKey
}

// [RSA] publicKey로 데이터 암호화
const encryptRSA = async function (password, publicKey) {
  const rsa = new RSAKey()
  const rsaPublicKeyModulus = publicKey.publicKeyModulus
  const rsaPublicKeyExponent = publicKey.publicKeyExponent
  await rsa.setPublic(rsaPublicKeyModulus, rsaPublicKeyExponent)
  return rsa.encrypt(password)
}

// // [AES] 키
// const getAESKey = function () {
//   const key = 'ETNERS_KIOSK_PRIVATE_KEY_32_BYTE'
//   return key;
// }
//
// // [AES] 암호화
// const encryptAES = function (data, key) {
//   const dataWA = enc.Utf8.parse(data);
//   const keyWA = enc.Utf8.parse(key);
//   const ivWA = enc.Utf8.parse(key.substring(0, 16));
//
//   const cipher = AES.encrypt(dataWA, keyWA, { iv: ivWA });
//   return cipher.ciphertext.toString(enc.Hex);
// }
//
// // [AES] 복호화
// const decryptAES = function (encData, key) {
//   const keyWA = enc.Utf8.parse(key);
//   const ivWA = enc.Utf8.parse(key.substring(0, 16));
//
//   const cipher = AES.decrypt(enc.Base64, keyWA, { iv: ivWA });
//   // const cipher = AES.decrypt(enc.Base64url.parse(encData.replace(/=/gi, '')).toString(enc.Base64), keyWA, { iv: ivWA }); // 해쉬된 값이 url encode 일 수도 있으므로 base64url 로 파싱하고 다시 base64 로 인코딩
//   return cipher.toString(enc.Utf8);
// }

export default {
  getRSA,
  encryptRSA,
  // encryptAES,
  // decryptAES,
  // getAESKey
}
